import DialogComponent from 'components/modal/dialog'

const CLASS_DIALOG_BD = 'dialog-msg-container'

let $vm, watcher

const methods = {
  _show (options) {
    watcher && watcher()

    let content, onConfirm, onCancel
    $vm.confirmText = '确定'
    if (typeof options === 'string') {
      content = options
    }

    if (typeof options === 'object') {
      content = options.content
      onConfirm = options.onConfirm
      onCancel = options.onCancel

      delete options.content
      delete options.onConfirm
      delete options.onCancel

      for (let k in options) {
        if (typeof options[k] !== 'undefined') {
          $vm[k] = options[k]
        }
      }

      if (options.onShow || options.onHide) {
        watcher = $vm.$watch('show', (val) => {
          let fn = options[val ? 'onShow' : 'onHide']
          fn && fn($vm)
        })
      }
    }

    $vm.$once('onConfirm', (e, data) => {
      $vm.show = false
      onConfirm && onConfirm(e, data, $vm)
    })

    $vm.$once('onCancel', (e, data) => {
      $vm.show = false
      onCancel && onCancel(e, data, $vm)
    })

    $vm.$nextTick(() => {
      $vm.$el.querySelector('.' + CLASS_DIALOG_BD).innerHTML = content
    })

    $vm.show = true
  },
  hide () {
    $vm.show = false
  },
  toggle () {
    $vm.show = !$vm.show
  }
}

const dialog = (options) => {
  if (typeof options === 'string' && !/^_/.test(options) && methods[options]) {
    methods[options]()
  } else {
    let type = 'alert'
    if (typeof options === 'object' && options.type) {
      type = options.type
      delete options.type
    }
    $vm.type = type
    methods._show(options)
  }
}

export default {
  install (Vue, options = {}) {
    if (!$vm) {
      let Dialog = Vue.extend(DialogComponent)
      let el = document.createElement('div')
      document.body.appendChild(el)
      $vm = new Dialog()
      $vm.$mount(el)
    }

    Vue.mixin({
      created () {
        this.$dialog = dialog
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/dialog.js